<div class="dialog-body">
    <form [formGroup]="agentForm" (ngSubmit)="onSubmit()" class="flex flex-column">


        <div class="field-group field-row">
            <label class="field-label">
                <i class="pi pi-sliders-h"></i> Model <span class="text-red-500">*</span>
            </label>
            <div class="model-row">
                <p-inputSwitch formControlName="isCommissionable"></p-inputSwitch>
                <span class="model-label">
                    {{ agentForm.get('isCommissionable')?.value ? 'Partner' : 'Non-Partner' }}
                </span>
            </div>
            <small class="p-error block mt-1" *ngIf="agentForm.get('isCommissionable')?.invalid && agentForm.get('isCommissionable')?.touched">
                This field is required
            </small>
        </div>

        <div class="field-group field-row">
           <label class="field-label">
        <i class="pi pi-users"></i> Agent
        <span class="text-red-500" *ngIf="agentForm.get('isCommissionable')?.value">*</span>
    </label>
            <p-dropdown [options]="agentOptions" formControlName="agent" placeholder="Select Agent" styleClass="w-full"
                appendTo="body" [showClear]="true">
            </p-dropdown>
            <small class="p-error block mt-1"
        *ngIf="agentForm.get('agent')?.invalid && agentForm.get('agent')?.touched">
        Agent is required for Partner
    </small>
            <!-- <small class="p-error block mt-1" *ngIf="agentForm.get('agent')?.invalid && agentForm.get('agent')?.touched">
                This field is required
            </small> -->
        </div>


        <div class="field-group field-row">
            <label class="field-label">
                <i class="pi pi-link"></i> Application Processing SOP
            </label>
            <input pInputText type="url" formControlName="sopLink" placeholder="https://docs.example.com/sop"
                class="sop-input w-full" />
        </div>


        <div class="field-group field-row">
            <label class="field-label">
                <i class="pi pi-wallet"></i> Application Fees
            </label>
            <div class="grid m-0" style="gap: 0.5rem;">
                <div class="col-4 p-0">
                    <p-dropdown [options]="currency" formControlName="currency" placeholder="Currency"
                        styleClass="w-full currency-dropdown" appendTo="body" optionLabel="label" optionValue="value">
                    </p-dropdown>
                </div>
                <div class="col p-0">
                    <p-inputNumber formControlName="applicationFees" [mode]="'currency'"
                        [currency]="agentForm.get('currency')?.value || 'USD'" [locale]="'en-US'" placeholder="0.00"
                        [min]="0" styleClass="w-full" class="w-full">
                    </p-inputNumber>
                </div>
            </div>
              <div class="flex align-items-center mt-2">
        <p-checkbox formControlName="feeWaiver" [binary]="true" inputId="feeWaiver"></p-checkbox>
        <label for="feeWaiver" class="ml-2 cursor-pointer">Fee Waiver</label>
    </div>
        </div>

        <div class="field-group field-row">
            <div class="intake-header">
                <label class="field-label mb-0">
                    <i class="pi pi-calendar"></i> Intake
                </label>
               
            </div>

            <div class="grid m-0" style="gap: 0.5rem;">
                <div class="col p-0">
                    <p-dropdown [options]="months" formControlName="intakeMonth" placeholder="Category" styleClass="w-full"
                        appendTo="body" [showClear]="true">
                    </p-dropdown>
                </div>
                <div class="col p-0">
                    <p-dropdown [options]="years" formControlName="intakeYear" placeholder="Year" styleClass="w-full"
                        appendTo="body" [showClear]="true">
                    </p-dropdown>
                </div>
            </div>
        </div>

        <div class="action-footer">
            <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-text" (onClick)="onClose()"
                [disabled]="isSaving">
            </p-button>
            <p-button label="Save Changes" icon="pi pi-check" type="submit" [disabled]="isSaving" [loading]="isSaving"
                styleClass="save-btn">
            </p-button>
        </div>

    </form>
</div>